'use client';

import React from 'react';
import Container from '../ui/Container';
import Grid from '../ui/Grid';

export type DualCardsProps = { items?: React.ReactNode[] } & React.PropsWithChildren;

const DualCards = ({ items, children }: DualCardsProps) => {
  return (
    <Container cx={{ mY: '3xl' }}>
      <Grid rowGutter>
        {children ||
          items?.map((item, i) => (
            <Grid.Col key={i} md={6}>
              {item}
            </Grid.Col>
          ))}
      </Grid>
    </Container>
  );
};

export default DualCards;
